import NumberPlayer from "./NumberPlayer/NumberPlayer.vue";
import NumberQuestion from "./NumberQuestion/NumberQuestion.vue";
import Timer from "./Timer/Timer.vue";

export default {
  NumberPlayer,
  NumberQuestion,
  Timer
}